var media = {
  palm: 'palm',
  lap: 'lap',
  desk: 'desk'
};
var queries = {
  palm: '(max-width: 668px)',
  lap: '(max-width: 1013px) and (min-width: 668px)',
  desk: '(min-width: 1014px)'
};
var getDeviceType = function getDeviceType() {
  for (var _i = 0, _Object$keys = Object.keys(queries); _i < _Object$keys.length; _i++) {
    var device = _Object$keys[_i];
    var _window$matchMedia = window.matchMedia(queries[device]),
      matches = _window$matchMedia.matches;
    if (matches) {
      return device;
    }
  }
};
export { getDeviceType, media };